import React from "react";
import TH from "./TH";
import TD from "./TD";
import type { FilingRow } from "../types";

export default function FilingsTable() {
  const currentYear = new Date().getFullYear();
  const dueDate = "01/03/" + (currentYear + 1);
  const period = "01/01/" + currentYear + " to 31/12/" + currentYear;

  const rows: FilingRow[] = [
    { name: "T4 summary", period, status: "Not due yet", dueDate, method: "Manually file" },
    { name: "T4 employer slips", period, status: "Not due yet", dueDate, method: "Manually file with XML" },
    { name: "T4 employee slips", period, status: "Not due yet", dueDate, method: "Manually file" },
  ];

  return (
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
      <thead>
        <tr>
          <TH>Filing</TH>
          <TH>Period</TH>
          <TH>Status</TH>
          <TH>Due date</TH>
          <TH>Method</TH>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            <TD bold>{r.name}</TD>
            <TD num>{r.period}</TD>
            <TD>{r.status}</TD>
            <TD num>{r.dueDate}</TD>
            <TD>{r.method}</TD>
          </tr>
        ))}
      </tbody>
    </table>
  );
}